import { render, staticRenderFns } from "./NewArrivalMessagesList.vue?vue&type=template&id=6a947b19&lang=pug"
import script from "./NewArrivalMessagesList.vue?vue&type=script&lang=ts"
export * from "./NewArrivalMessagesList.vue?vue&type=script&lang=ts"
import style0 from "./NewArrivalMessagesList.vue?vue&type=style&index=0&id=6a947b19&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports